module.exports = {"loading":"Nahrávam dáta","text":"Táto operácia môže trvať niekoľko sekúnd, majte prosím strpenie..."}